<template>
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        批量管理
        <small>只限智能电表</small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <a href="#"> <i class="fa fa-dashboard"></i> 批量管理 </a>
        </li>
        <li class="active">批量管理</li>
      </ol>
    </section>
    <!-- Main content -->
    <section class="content" style="background: #fff">
      <!-- Main row -->
      <div class="row col-sm-12">
        <div class="wrapper-content animated fadeInRight">
          <div class="ibox float-e-margins">
            <div class="ibox-content form-horizontal">
              <div id="atptoolbar">
                <div class="form-group">
                  <label class="col-sm-3 control-label">分管运营商:</label>
                  <div class="col-sm-3">
                    <select
                      class="chosen-select-batch"
                      data-type="comm_value"
                      v-model="searchParam.comm_value"
                    >
                      <option value>选择分管运营商</option>
                      <option
                        v-for="(item, index) in sub_comm"
                        :key="index"
                        :value="item.name"
                      >
                        {{ item.name }}
                      </option>
                    </select>
                  </div>
                  <label class="col-sm-3 control-label">代维公司:</label>
                  <div class="col-sm-3">
                    <select
                      class="chosen-select-batch"
                      data-type="maintain_value"
                      v-model="searchParam.maintain_value"
                    >
                      <option value>请选择</option>
                      <option
                        v-for="(item, index) in maintain"
                        :key="index"
                        :value="item.id"
                      >
                        {{ item.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-sm-3 control-label">代缴公司:</label>
                  <div class="col-sm-3">
                    <select
                      class="chosen-select-batch"
                      data-type="pay_value"
                      v-model="searchParam.pay_value"
                    >
                      <option value>请选择</option>
                      <option
                        v-for="(item, index) in payCompany"
                        :key="index"
                        :value="item.id"
                      >
                        {{ item.name }}
                      </option>
                    </select>
                  </div>
                  <label class="col-sm-3 control-label">代谈公司:</label>
                  <div class="col-sm-3">
                    <select
                      class="chosen-select-batch"
                      data-type="talk_value"
                      v-model="searchParam.talk_value"
                    >
                      <option value>请选择</option>
                      <option
                        v-for="(item, index) in talkCompany"
                        :key="index"
                        :value="item.id"
                      >
                        {{ item.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-sm-10"></div>
                <button
                  class="btn btn-info"
                  type="button"
                  id="sys_recordbutton"
                  @click="smartTab('close')"
                  v-show="idType"
                >
                  拉闸
                </button>
                <button
                  class="btn btn-info"
                  type="button"
                  id="sys_recordbutton"
                  @click="smartTab('open')"
                  v-show="idType"
                >
                  合闸
                </button>
              </div>
              <table id="batch_atptable"></table>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      sub_comm: [], // 所有的分管运营商
      maintain: [], //代维公司
      payCompany: {}, // 代缴公司
      talkCompany: [], // 代谈公司
      searchParam: {
        comm_value: "",
        maintain_value: "",
        pay_value: "",
        talk_value: "",
      },
      idType: true,
      companyId: "",
    };
  },
  components: {},
  mounted: function () {
    var self = this;
    // 运营商身份不显示拉合闸
    var companyInfo = JSON.parse(localStorage.getItem("companyInfo"));
    if (companyInfo.type == "运营商") {
      self.idType = false;
    } else {
      self.idType = true;
    }
    self.companyId = companyInfo.id;

    $(".chosen-select-batch")
      .chosen({
        disable_search_threshold: 10,
        disable_search: true,
        width: "100%",
      })
      .change(function () {
        var type = $(this).attr("data-type");
        self.searchParam[type] = $(this).val();
        $("#batch_atptable").bootstrapTable("refresh");
      });
    self.getSelectValue(0, 4);

    $("#batch_atptable").bootstrapTable({
      url: self.global.apiHost + "ammeters/", //请求后台的URL（*）
      method: "get", //请求方式（*）
      ajaxOptions: {
        headers: {
          "content-type": "application/json", // 默认值
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
      },
      // toolbar: "#atptoolbar", //工具按钮用哪个容器
      height: $(window).height() * 0.7,
      striped: true, //是否显示行间隔色
      cache: false, //是否使用缓存，默认为true，所以一般情况下需要设置一下这个属性（*）
      pagination: true, //是否显示分页（*）
      iconSize: "outline",
      sortable: false, //是否启用排序
      // sortName: "stam_atpid",
      sortOrder: "DESC",
      queryParams: self.queryParams, //传递参数（*）
      sidePagination: "server", //分页方式：client客户端分页，server服务端分页（*）
      pageNumber: 1, //初始化加载第一页，默认第一页
      pageSize: 100, //每页的记录行数（*）
      pageList: [100], //可供选择的每页的行数（*）
      search: true, //是否显示表格搜索，此搜索是客户端搜索，不会进服务端，所以，个人感觉意义不大
      showColumns: false, //是否显示所有的列
      showRefresh: true, //是否显示刷新按钮
      minimumCountColumns: 2, //最少允许的列数
      clickToSelect: true, //是否启用点击选中行
      uniqueId: "stam_atpid", //每一行的唯一标识，一般为主键列
      singleSelect: false,
      // 只显示智能分表  C 智能分表  D 智能总表
      responseHandler: function (res) {
        console.log("-------", res);
        return {
          total: res.rows.filter((item) => item.stam_category == "C").length, //总页数
          rows: res.rows.filter((item) => item.stam_category == "C"), //数据
        };
      },
      columns: [
        [
          { checkbox: true },
          {
            title: "序号",
            width: 40,
            formatter: function (value, row, index) {
              var option = $("#batch_atptable").bootstrapTable("getOptions");
              return option.pageSize * (option.pageNumber - 1) + index + 1;
            },
          },
          {
            field: "ammeter_numbering",
            title: "电表编号",
            sortable: true,
            width: 150,
          },
          {
            field: "stst_commname",
            title: "基站名称",
            sortable: true,
            width: 150,
          },
          {
            field: "stst_comm",
            title: "运营商",
            sortable: true,
            width: 150,
          },
          {
            field: "stst_address",
            title: "位置",
            sortable: true,
            width: 150,
          },
          {
            field: "stst_type",
            title: "类型",
            sortable: true,
            width: 150,
          },
        ],
      ],
    });
  },
  methods: {
    smartTab(param) {
      var self = this;
      var r = confirm("您确定要进行该项操作吗?\n响应时间较长,请耐心等候"); // 询问框里的文字描述
      if (r == true) {
        var selectOptions =
          $("#batch_atptable").bootstrapTable("getSelections");
        self.ammeterSmart(selectOptions, 0, selectOptions.length, param);
      } else {
        console.log("取消");
      }
    },
    // 请求拉合闸接口
    ammeterSmart(selectOptions, i, l, param) {
      var self = this;
      self.global.axiosPost(
        self,
        "ammeter/" + selectOptions[i].id + "/" + param + "/",
        {},
        function (d) {
          if (d.commandId) {
            //alert("操作成功!");
          } else {
            alert(
              "电表编号" +
                selectOptions[i].ammeter_numbering +
                "操作失败,请稍后重试!"
            );
          }
          if (++i < length) {
            that.ammeterSmart(selectOptions, i, l, param);
          } else {
            alert("操作成功!");
          }
        },
        function (res) {
          alert(
            "电表编号" +
              selectOptions[i].ammeter_numbering +
              "操作失败:没有权限"
          );
        }
      );
    },
    // 获取select的内容 params:(索引值,长度)
    getSelectValue(i, l) {
      var self = this;
      var searchKey = [
        {
          name: "运营商",
          field: "sub_comm",
        },
        {
          name: "代维公司",
          field: "maintain",
        },
        {
          name: "代缴公司",
          field: "payCompany",
        },
        {
          name: "代谈公司",
          field: "talkCompany",
        },
      ];
      var field = searchKey[i].field;
      self.global.axiosGet(
        self,
        "organizations/?search=" + searchKey[i].name,
        function (res) {
          self[field] = res;
          setTimeout(function () {
            $(".chosen-select-batch").trigger("chosen:updated");
          }, 300);
          console.log(searchKey[i].name, i, res);
          if (++i < l) {
            self.getSelectValue(i, l);
          }
        }
      );
    },
    queryParams: function (params) {
      var self = this;
      params.per_page = params.limit;
      // params.page = params.offset / params.limit + 1;
      params.model = "lot";
      params.sub_comm = self.searchParam.comm_value; // 分管运营商
      params.proxy_talk = self.searchParam.talk_value; // 代谈公司
      params.proxy_maintain = self.searchParam.maintain_value; //代维公司
      params.proxy_payment = self.searchParam.pay_value; //代缴公司
      params.org_id = self.companyId;
      return params;
    },
  },
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/stationManager/batchManagement.vue